import { Component, Input, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StoreService } from 'src/app/services/store.service';
import { ToastService } from 'src/app/services/toast.service';
import { UserService } from 'src/app/services/user.service';
import {ActivatedRoute, NavigationExtras, RoutesRecognized } from '@angular/router';
import { AlertController } from '@ionic/angular';

import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';

import { Platform } from '@ionic/angular';
import { ActionSheetController } from '@ionic/angular';
@Component({
  selector: 'app-category-list',
  templateUrl: './category-list.page.html',
  styleUrls: ['./category-list.page.scss'],
})
export class CategoryListPage implements OnInit {
  productList: any;
  city = localStorage.getItem('city');
  pin: any;
  locationFlag: any;
  page_number: any;
  recommendedProducts: any;
  productListA: any;
  bannerImg: any;
  middleImgbottom: any;
  merChat: any;
  category: any = "";
  n: any;
  selectRef: any;
  location:any;
  locationJs: any;
  cart: any = [];
    qty: number = 1;
    show: any;
   @Input() item;
   subCategory: any;
   userId = localStorage.getItem("userId");
   loading : boolean=false;
   a:boolean=false;
  offset: number;
  isLoading: boolean;
  searchResultData: any = [];
  count: any;
  limit:any
  noDataImage: boolean = false;
  productFound: boolean = false;
  check: any = 0;
   constructor( private userService: UserService,private authService : StoreService, private toast : ToastService, private router : Router,
  
      private routerActivate: ActivatedRoute,
      public alertController : AlertController,
   
      private service: StoreService,
      private appVersion: AppVersion,
      private platform: Platform,
      public actionSheetController: ActionSheetController,
      private _platform: Platform,
      private ngZone: NgZone,
    ) {
        this.userService.cartUpdated.subscribe(res => {
          let cart = localStorage.getItem('cart');
          if(cart){
            this.n = JSON.parse(cart).length;
          }
        })
       }
 

  ngOnInit() {
    this.category=this.routerActivate.snapshot.params.category;
    this.subCategory=this.routerActivate.snapshot.params.subCat;
    if(this.subCategory==0){
      this.subCategory=""
    }
    console.log(this.city)
    if (this.city != null && this.city != '') {
      localStorage.setItem('city', this.city);
    }
    if (this.pin != null && this.pin != '') {
      localStorage.setItem('pin', this.pin);
    }
    // this.storageService.get(AuthConstants.AUTH_USERDATA).then((data) => {
    //   this.userId = data
    // })
    //this.userId = localStorage.getItem('userId');
    this.city = localStorage.getItem('city');
    if (this.city != null) {
      this.locationFlag = 3;
    }
    this.pin = localStorage.getItem('pin')
    if (this.pin != null) {
      this.locationFlag = 2;
    }
    this.searchResultData = ""

    this.ionViewWillEnter()
    this.userService.appSettings.subscribe((resp:any) => {
      console.log("appSettings resp version ", resp.version);
      if(resp && resp.checkVersion && resp.version){
        console.log("resp.version ", resp.version);
        this.appVersion.getVersionNumber().then(version => {
          console.log("this.appVersion.getVersionNumber() ", version);
          if(resp.version != version){
            // this.updateAlertConfirm();
          }
        });
      }
    })

    if (!localStorage.getItem('city')) {
      this.AddController();
    }
    this.fetchProductLimit();
    this.topBannerImage();
    this.middleBannerImage();

    this.pin = localStorage.getItem('pin')
  
  }
  ionViewWillEnter(){
    this.listOfProduct()
    }
    listOfProduct() {
      let categoryName = this.router.url;
      let parts = categoryName.split('/');
      let finalCategory = parts[2];
      console.log("category clicked is", finalCategory);
      
      var cart = JSON.parse(localStorage.getItem("cart"));
      this.productList = [];
      this.isLoading = true;  // Set loading state to true
      
      const promoListobj = { search: finalCategory, city: this.city, limit: 500, offset: 0 };
      console.log("xcdc", promoListobj);
    
      // Make the API request
      this.authService.getProduct(promoListobj).subscribe((data: any) => {
        this.isLoading = false;  // Set loading state to false once data is received
    
        // Handle different response codes
        if (data.code == 2 && this.page_number == 1 || data.code == 3 && this.page_number == 1) {
          this.noDataImage = true;
        } else {
          // Loop through the data and check for existing products
          for (let i = 0; i < data.length; i++) {
            this.productFound = true;
            this.count = 0;
    
            // Check if the product is already in the list
            for (let j = 0; j < this.productList.length; j++) {
              if (this.productList[j].articleNumber == data[i].articleNumber) {
                this.count++;
              }
            }
    
            // If product is not already in the list, add it
            if (this.count == 0) {
              this.productList.push(data[i]);
              
              // Check if the product is in the cart and update the quantity
              var product = cart.filter((element: any) => element.id == this.productList[i]._id)[0];
              if (product) {
                this.productList[i]['qty'] = product.qty;
              }
            }
          }
    
         
        }
    
        // Set check to determine if no products were found
        if (this.productList.length > 0) {
          this.check = 0;
        } else {
          this.check = 1;
          console.log("No products found");
        }
    
      }, (error: any) => {
        this.isLoading = false;  // Set loading state to false on error
        console.error("Error fetching products", error);
      });
    }
    

 
   handleAddToCart(productObj) {
     let promoListobj = {
       productdetails: productObj,
       userId: this.userId
     }
    
     this.authService.addToCart(promoListobj)
       .subscribe((result: any) => {
         this.toast.presentToast("Product added in your cart")
       }, (error: any) => {
       });
   }
   
   productDetail(productItem: any) {
     console.log("hello hi ", productItem)
     this.router.navigate(['./product-detail/'+productItem._id])
   }
  
 
   // onImageLoad(item){
   //   console.log("hii")
   //   item.image=true;
   //   this.loading=true;
   //   if(item.image==true){
   //     this.a='visible'
   //   }
   //   else{
   //     this.a='none'
   //   }
   // }
 
   handleMissingImage($event){
     console.log($event)
     console.log("hello error");
     ($event.target as HTMLImageElement).style.display = 'none'
     this.a=true;
   }
   handleAddToCarta(productObj) {
     console.log("productObj ", productObj)
     this.cart = []
     let cart = localStorage.getItem("cart");
     if (cart) {
       this.cart = JSON.parse(cart);
       console.log("cart ", this.cart)
       let filtered = this.cart.filter(product => product.id == productObj._id)
       console.log("filtered ", filtered)
       if (filtered.length == 0) {
         var pdata = {
           id: productObj._id,
           qty: this.qty
         }
         console.log(pdata)
         this.cart.push(pdata)
         localStorage.setItem('cart', JSON.stringify(this.cart))
         this.show = 1
       } else {
         console.log(this.show)
         let index = this.cart.indexOf(filtered[0]);
         console.log("index ", index)
         this.cart.splice(index, 1)
         localStorage.setItem('cart', JSON.stringify(this.cart))
         this.show = null
 
       }
     } else {
       console.log("item._id ", productObj._id)
       var pdata = {
         id: productObj._id,
         qty: this.qty
       }
       this.cart.push(pdata)
       localStorage.setItem('cart', JSON.stringify(this.cart))
       this.show = 1
     }
     this.userService.cartUpdated.next(true);
   }
   isRetailer(){
     if(localStorage.getItem('retailerEnabled')=="1") 
      return true;
    }

    reload(){
      window.location.reload()
    }
  
    fetchCatStoreTerm() {
      let navigationParams: NavigationExtras = { state: { city: this.city, pin: this.pin, backPageFlag: { backPageFlagInfo: "H", city: this.city, pin: this.pin } } };
      this.router.navigate(['/search-product'], navigationParams);
    }
  
    wishlist() {
      this.router.navigate(['/wishlist'])
    }
    Myprofile(){
      this.router.navigate(['/profile'])
    }
  
    cart1() {
      this.router.navigate(['/cart'])
    }
  
    loginmobile() {
      this.router.navigate(['/account-page'])
    }
    nearby(){
      this.router.navigate(['/nearby'])
    }
    wallet(){
      this.router.navigate(['/spot-wallet'])
    }
  
    async AddController() {
      const actionSheet = await this.actionSheetController.create({
        header: 'Choose Location',
        cssClass: 'action-search-custom-class',
        buttons: [
          // {
          //   text: 'Zip Code',
          //   icon: 'pin-outline',
          //   handler: () => {
          //     this.locationFlag = 2;
          //     this.page_number = 1;
          //     this.enterSerachkeyword(this.locationFlag)
          //     console.log('Share clicked');
          //   }
          // }, 
          {
            text: 'City',
            icon: 'business-outline',
            handler: () => {
              this.locationFlag = 3;
              this.page_number = 1;
              // this.enterSerachkeyword(this.locationFlag)
              this.enterCityRadio(this.locationFlag)
              console.log('Play clicked');
            }
          }
        ]
      });
      await actionSheet.present();
  
      const { role } = await actionSheet.onDidDismiss();
    }
    fetchProductLimit() {
      const proObj = {}
      this.service.webProductCat(proObj).subscribe((result: any) => {
  
        this.productListA = result.msg
        console.log(this.productListA)
      }, (error: any) => {
        this.toast.presentToast(error)
      });
    }
    topBannerImage() {
      this.service.topBannerImg().subscribe((result: any) => {
        console.log("Response banner image", result)
        this.bannerImg = result
        this.merchantCatList()
      }, (error: any) => {
        this.toast.presentToast(error)
  
      });
    }
  
    middleBannerImage() {
      let that = this;
      const DisObj = {
        city: this.city
      }
      this.service.middleBannerImg1(DisObj).subscribe((result: any) => {
  
        this.ngZone.run(() => {
          console.log("result ", result)
          that.middleImgbottom = result;
          console.log("that.middleImgbottom ", that.middleImgbottom)
        });
  
      }, (error: any) => {
  
      });
    }
    async enterCityRadio(flag: number) {
      const alert = await this.alertController.create({
        cssClass: 'my-custom-class',
        header: 'Select City',
        inputs: [{
            name: 'radio1',
            type: 'radio',
            label: 'Kanpur',
            value: 'Kanpur',
  
          },
          {
            name: 'radio1',
            type: 'radio',
            label: 'Lucknow',
            value: 'Lucknow',
            // handler: () => {
            //   console.log('Radio 1 selected');
            // },
          },
          {
            name: 'radio1',
            type: 'radio',
            label: 'Delhi NCR',
            value: 'Delhi NCR',
  
          },
        ],
        buttons: [{
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
  
            //  console.log('Confirm Cancel: blah');
          }
        }, {
          text: 'OK',
          handler: (data) => {
            if (flag == 3) {
              //flag use for enter "city" keyword
              this.productList = [];
              this.page_number = 1;
              localStorage.setItem('city', data);
              this.city = data;
              localStorage.setItem('pin', '');
              this.pin = null;
              console.log('Confirm flag == 3', this.city);
              this.recommendedProducts = [];
              this.middleBannerImage();
              //this.recommandedProductList();
            }
            window.location.reload();
          }
        }]
      });
  
      await alert.present();
    }
    merchantCatList() {
      this.service.preDifnedCat().subscribe((result: any) => {
        console.log("Response from merchandied catagories", result)
        this.merChat = result
  
      }, (error: any) => {
        this.toast.presentToast(error)
      });
    }
    app(){
      window.open("https://play.google.com/store/apps/details?id=com.spot.mckinsol&hl=en_IN&gl=US")
    }
    fetchCatStoreTerm1() {
      let navigationParams: NavigationExtras = { state: { city: this.city, pin: this.pin, backPageFlag: { backPageFlagInfo: "H", city: this.city, pin: this.pin } } };
      this.router.navigate(['/search-product'], navigationParams);
    }
  
}
